import React, { Component } from "react";
import * as FlexLayout from "flexlayout-react";
import QualityAttributeValues from "./qualityAttributeValues";
import QualityAttributeValue from "./qualityAttributeValue";
import { withTranslation } from "react-i18next";

class QualityAttributeValueAdmin extends Component {
  LAYOUT = {
    global: {
      minWidth: 100,
      minHeight: 100,
    },
    borders: [],
    layout: {
      type: "row",
      children: [
        {
          type: "tabset",
          weight: 50,
          enableMaximize: false,
          children: [
            {
              type: "tab",
              name: this.props.t("QualityAttributeValues"),
              enableClose: false,
              component: "QualityAttributeValues",
            },
          ],
        },
        {
          //Figure out how to make this persistent even when empty.
          type: "tabset",
          id: "1",
          weight: 50,
          enableDeleteWhenEmpty: false,
          enableMaximize: false,
          children: [
            // {
            //   type: "tab",
            //   name: "User",
            //   visible: false,
            //   component: "Placeholder"
            // }
          ],
        },
      ],
    },
  };

  state = {
    model: FlexLayout.Model.fromJson(this.LAYOUT),
  };

  handleQualityAttributeValueSelect = (
    QualityAttributeValue,
    submitCallbackFunction,
    isNew
  ) => {
    const { qualityAttributeValueId, value } = QualityAttributeValue;

    try {
      this.state.model.doAction(
        FlexLayout.Actions.addNode(
          {
            type: "tab",
            component: "QualityAttributeValue",
            name: `${value}`,
            id: `${qualityAttributeValueId}`,
            config: { qualityAttributeValueId, submitCallbackFunction, isNew },
          },
          "1",
          FlexLayout.DockLocation.CENTER,
          0,
          true
        )
      );
    } catch {
      this.state.model.doAction(
        FlexLayout.Actions.selectTab(qualityAttributeValueId)
      );
    }
  };

  handleTabRename = (nodeId, value) => {
    this.state.model.doAction(
      FlexLayout.Actions.updateNodeAttributes(nodeId, { name: value })
    );
  };

  factory = (node) => {
    const componentId = node.getComponent();
    //const QualityAttributeValueId = node.getId();

    if (componentId === "QualityAttributeValues") {
      return (
        <QualityAttributeValues
          onClick={this.handleQualityAttributeValueSelect}
          allowEdit={this.props.allowEdit}
        />
      );
    } else if (componentId === "QualityAttributeValue") {
      const { qualityAttributeValueId, submitCallbackFunction, isNew } =
        node.getConfig();
      return (
        <QualityAttributeValue
          qualityAttributeValueId={qualityAttributeValueId}
          submitCallbackFunction={submitCallbackFunction}
          isNew={isNew}
          onRename={this.handleTabRename}
          allowEdit={this.props.allowEdit}
        />
      );
    } else if (componentId === "Placeholder") {
      return <div></div>;
    } else {
      return null;
    }
  };

  buildFlexLayout = () => {
    return (
      <div className="flex-container">
        <FlexLayout.Layout model={this.state.model} factory={this.factory} />;
      </div>
    );
  };

  render() {
    return this.buildFlexLayout();
  }
}

export default withTranslation(["products"])(QualityAttributeValueAdmin);
